import { render, staticRenderFns } from "./member-oauth2-client-list.vue?vue&type=template&id=c350a13a&"
import script from "./member-oauth2-client-list.vue?vue&type=script&lang=js&"
export * from "./member-oauth2-client-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports